import React, { Component } from "react";
import { dispatch } from '@rematch/core';
import { categoryTreeService, checkCategoryService, categoriesService, copyCategoryService, defaultCategoryService, categoryTreeByAccessService } from '../../services/feathers.service';
import { toastr } from 'react-redux-toastr';

const initialState = {
    allCategoryList: null,
    categoryTreeById: null,
    catagoryAttachedDetails: null,
    categoryTreeList: [],
    categoryListLoader:false
};

export default {
    state: initialState,
    reducers: {

        setCategories(state, payload) {
            return {
                ...state,
                allCategoryList: payload
            }
        },
        setCategoryById(state, payload) {
            return {
                ...state,
                categoryTreeById: payload
            }
        },
        setCategoryAttachedData(state, payload) {
            return {
                ...state,
                catagoryAttachedDetails: payload
            }
        },
        setcategoryTreeByAccess(state, payload = []) {
            return {
                ...state,
                categoryTreeList: payload
            }
        },
        clear() {
            return initialState
        },
        setCategoryLoader(state, payload) {
            return {
                ...state,
                categoryListLoader: payload
            }
        },
    },

    effects: {
        clearAsync() {
            dispatch.categories.clear();
        },
        async getAllCategories(payload, state) {
            try {
                let query = {
                    accountId: state.app.selectedAccount._id,
                }

                let category = await categoryTreeService.find({
                    query: query,
                    accountOnly: state.app.selectedOrganisation._id ? false : true
                });
                await dispatch.categories.setCategoryById(category);
                await dispatch.categories.setCategories(category);
            } catch (error) {
                throw error;
            }
        },
        async getCategoryById(payload, state) {
            try {
                let query = {
                    $populate: [
                        { path: 'children', populate: 'children' },
                    ]
                }
                let subCategories = await categoriesService.get(payload, {
                    query: query,
                    accountOnly: state.app.selectedOrganisation._id ? false : true
                });
                subCategories.children = subCategories.children.sort((a, b) => ('' + a.slug).localeCompare(b.slug))
                await dispatch.categories.setCategoryById(subCategories.children);
            } catch (error) {
                throw error;
            }
        },
        async createCategory(payload, state) {
            try {

                await categoriesService.create(payload);

                //For create category
                let data = {
                    "accountId": payload.accountId,
                    isKb: payload.isKb,
                    isCategory: payload.isCategory,
                    isSubCategory: payload.isSubCategory,
                }
                if (payload.parent) {
                    data.parent = payload.parent
                }
                await dispatch.lifeCycle.getCategoryAsync(data);

                //For referesh data
                payload.categoryType = payload.isKb ? "baseCategory" :
                    payload.isCategory === "category" ? "category" :
                        payload.isSubCategory === "subCategory" ? "subCategory" : null
                payload.paramId = payload.parent
                //dispatch.categories.socketRefresh(payload)

            }
            catch (error) {
                throw error;
            }
        },
        async updateSelectedCategory(payload, state) {

            try {
                await dispatch.categories.setCategoryLoader(true);
                let updateValue;

                if (payload.updatedName) {
                    updateValue = { 'name': payload.updatedName }
                }
                if (payload.image) {
                    updateValue = { 'image': payload.image }
                }

                await categoriesService.patch(payload._id, {
                    $set: updateValue,
                    workspaceId:payload.workspaceId
                });
                await dispatch.lifeCycle.getCategoryAsync({ "accountId": payload.accountId });


            }
            catch (error) {
                throw error;
            }
        },

        async copyCategory(payload) {
            try {
                await dispatch.categories.setCategoryLoader(true);
                await copyCategoryService.create(payload);

            }
            catch (error) {
                throw error;
            }
        },
        async deleteCategory(payload) {
            try {
                let query={
                    workspaceId:payload.organizationId
                }
                await categoriesService.remove(payload.categoryId,{query});
                await dispatch.account.setSelectedCategoryAsync({})

                let data = { "accountId": payload.accountId }
                if (!payload.organizationId) {
                    data.accountOnly = true
                }
                await dispatch.lifeCycle.getCategoryTreeAsync(data);
                if (payload.levelDepth === 'baseCategory') {
                    await dispatch.lifeCycle.getCategoryTreeAsync(data);
                }
                else if (payload.levelDepth === 'category') {
                    await dispatch.lifeCycle.getCategoryTreeAsync(data);
                    await dispatch.account.setIsCategoryChange(true);
                }
                else if (payload.levelDepth === 'subCategory') {
                    await dispatch.account.setIsCategoryChange(true);
                }

            }
            catch (error) {
                throw error;
            }
        },
        makeDefault(payload) {
            defaultCategoryService.create(payload);


        },
        socketRefresh(data, state) {
            let list = state.categories.categoryTreeById
            let setName = data.isKb ? "Knowledge Bank" :
                data.isCategory ? "Category" :
                    data.isSubCategory ? "Sub Category" : "Category"


            if (data.socketAction === "patched") {
                if (list && list.length !== 0) {
                    for (let i = 0; i < list.length; i++) {
                        if (list[i]._id === data._id) {
                            list[i] = data;
                            data.actionTypeMsg = "updated successfully."
                            toastr.success('Message', setName + " updated successfully.")
                        }else if (list[i]._id === data.parent){ // for import sub category KLM-9402
                            data.actionTypeMsg = "updated successfully."
                            toastr.success('Message', setName + " updated successfully.")
                        }
                    }
                }
            } else if (data.socketAction === "create" || data.socketAction === "categoryCopied") {
                if ((!data.organizationId && data.accountId === state.app.selectedAccount._id) ||
                    (data.organizationId && state.app.selectedOrganisation && data.organizationId === state.app.selectedOrganisation._id) ||
                    (data.organizationId && state.app.selectedOrganisation && data.organizationId === state.app.selectedOrganisation.id)) {
                    list && list.push(data)
                    toastr.success('Message', setName + " created successfully.")
                }
            } else if (data.socketAction === "removed") {
                if (list && list.length !== 0) {
                    for (let i = 0; i < list.length; i++) {
                        if (list[i]._id === data._id) {
                            list.splice(i, 1);
                            toastr.success('Message', setName + " deleted successfully.")
                        }
                    }
                }
            }

            var collator = new Intl.Collator(undefined, {
                numeric: true,
                sensitivity: 'base'
            });

            list && list.sort((a, b) => {
                return collator.compare(a.name, b.name)
            })

            dispatch.categories.setCategoryById(list)
            if(data.socketAction === "create" && data.parent){
                let categories = [...state.categories.allCategoryList]
               let index = state.categories.allCategoryList.findIndex((kb)=>kb._id === data.parent)
               if(index !== -1){
                categories[index].nodes = list
                dispatch.categories.setCategories(categories);
               }
            }
            // dispatch.categories.getAllCategories()
            setTimeout(() => {
                dispatch.categories.setCategoryLoader(false);
            }, 3000); 
        },
        categoryAttachedData(payload) {
            dispatch.categories.setCategoryAttachedData(payload)
        },
        async deleteSpecificCategory(payload, state) {

            try {
                let result = await checkCategoryService.find({ query: payload });
                if (result.code === 200) {
                    let message = <div className="confirmMessage">
                        <h3>Delete {payload.isKb ? "Knowledge Bank" : payload.isCategory ? "Category" : payload.isSubCategory ? "Sub Category" : null}</h3>
                        <label>{payload.name}</label>
                        <p>Are you sure that you wish to remove?</p>
                        <span>This action is not reversible</span>
                    </div>
                    toastr.confirm(message, {
                        onOk: async () => {
                            let nodeToAdd = {
                                accountId: payload.accountId,
                                categoryId: payload._id,
                                categoryTreeId: payload._id,
                                categoryType: payload.isKb ? "baseCategory" : payload.isCategory ? "category" : payload.isSubCategory ? "subCategory" : null,
                                paramId: payload.paramId,
                                workspaceId : payload.organizationId
                            }
                            if (payload.organizationId) {
                                nodeToAdd.organizationId = payload.organizationId
                                nodeToAdd.workspaceId = payload.organizationId
                            }
                            try {
                                await dispatch.categories.setCategoryLoader(true);
                                await dispatch.categories.deleteCategory(nodeToAdd);
                                await dispatch.lifeCycle.getCategoryAsync({ "accountId": payload.accountId });
                            }
                            catch (error) {
                            }
                        }
                    });
                } else {
                    await dispatch.categories.categoryAttachedData(result)
                    dispatch.account.setDeleteCategoryModal(true, payload);
                }
            } catch (e) {
                throw e;
            }
        },

        async categoryAttachData(payload) {
            try {

                let result = await checkCategoryService.find({ query: payload });
                await dispatch.categories.categoryAttachedData(result)
                if (payload.actionType === "Delete") {
                    if (result.code === 200) {
                        dispatch.categories.deleteSpecificCategory(payload)
                    } else {
                        dispatch.account.setDeleteCategoryModal(true, payload);
                    }
                }
                if (payload.actionType === "Usage") {
                    dispatch.account.setDeleteCategoryModal(true, payload);
                }

            } catch (e) {
                throw e;
            }
        },
        async getCategoryTreeByAccess(payload, state) {
            try {
                dispatch.lifeCycle.setError(null);

                // Get Category Tree
                let cT = await categoryTreeByAccessService.find({
                    query: {
                        accountId: payload ? payload.accountId : state.app.selectedAccount._id,
                        access: payload.access
                    },
                    accountOnly: payload && payload.accountOnly ? true : false
                });
                // Alpha numeric Function
                var collator = new Intl.Collator(undefined, {
                    numeric: true,
                    sensitivity: 'base'
                });
                cT = cT && cT.length !== 0 ?
                    cT && cT.length !== 0 && cT.sort((a, b) => {
                        return collator.compare(a.name, b.name)
                    }) : []

                for (let i = 0; i < cT.length; i++) {
                    if (cT[i].nodes && cT[i].nodes.length !== 0) {
                        for (let j = 0; j < cT[i].nodes.length; j++) {
                            cT[i].nodes && cT[i].nodes.length !== 0 && cT[i].nodes.sort((a, b) => {
                                return a && b && collator.compare(a.name, b.name)
                            })
                        }
                    }
                }

                await dispatch.categories.setcategoryTreeByAccess(cT);

            } catch (err) {
                dispatch.categories.setError(err);
                toastr.error('Message', 'Failed to get category ')
                throw err;
            }
        },
    }
}